import * as RadixDialog from '@radix-ui/react-dialog';

type DialogPortalProps = {} & RadixDialog.DialogPortalProps;

const DialogPortal = ({ children, ...props }: DialogPortalProps) => (
  <RadixDialog.Portal {...props}>{children}</RadixDialog.Portal>
);

export { DialogPortal, type DialogPortalProps };
